import { CheckoutServiceURL } from '../constants/checkout-constants';
import API from './api';
import { logError } from '../../../utils/console-utility';

class CouponDetails {
  // at last change hasApplied to getCouponData
  static async getCouponData(custSeq, productId, promoCode: string): Promise<any> {
  // get coupon data
  const response = await API.get(`${CheckoutServiceURL.APPLY_COUPON_URL}/promoCode?custSeq=${custSeq}&productId=${productId}&promoCode=${promoCode}`).catch((err) => {
    logError('Error fetching and parsing data - order details ', err)
  })
    return response ? response.data : {};
  }
    
}

export default CouponDetails;